export const DataImportStatus = {
  Complete: 'complete',
  Failed: 'failed',
  Importing: 'importing',
  InitiatingImport: 'initiatingImport',
  NotStarted: 'notstarted',
  Valid: 'valid',
  Validating: 'validating',
} as const;

export type DataImportStatus =
  (typeof DataImportStatus)[keyof typeof DataImportStatus];
